




import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component<IssueDivider>({})
export default class IssueDivider extends Vue {}
